const ABSOLUTE_URL_PATTERN = /^https?:\/\//i;

function trimTrailingSlash(value: string) {
  return value.replace(/\/+$/, "");
}

export const API_BASE_URL = trimTrailingSlash((import.meta.env.VITE_API_URL ?? "").trim());

export function resolveApiUrl(path: string, baseUrl = API_BASE_URL) {
  const normalizedBaseUrl = trimTrailingSlash(baseUrl.trim());

  if (ABSOLUTE_URL_PATTERN.test(path) || normalizedBaseUrl.length === 0) {
    return path;
  }

  if (path.startsWith("/")) {
    return `${normalizedBaseUrl}${path}`;
  }

  return `${normalizedBaseUrl}/${path}`;
}

export function resolveOptionalApiUrl(
  path: string | null | undefined,
  baseUrl = API_BASE_URL
) {
  return path ? resolveApiUrl(path, baseUrl) : undefined;
}
